export default __webpack_public_path__ + "static/media/prisma.a54ac25b.jpg";